var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tiktok-icon",
    transform: "translate(-1372 -4666)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 41,
    height: 41,
    rx: 7,
    transform: "translate(1372 4666)",
    fill: "rgba(102,170,71,0.19)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tiktok",
    transform: "translate(1381.939 4675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M161.728,136.13H165.7a5.962,5.962,0,0,0,5.677,5.7v3.895a9.628,9.628,0,0,1-5.621-1.787v8.395a7.418,7.418,0,1,1-8.559-7.472,14.653,14.653,0,0,1,2.124-.022s.017,2.767.017,3.952a11.791,11.791,0,0,0-1.795.107,3.4,3.4,0,0,0-2.616,3.955,3.5,3.5,0,0,0,3.566,2.8,3.4,3.4,0,0,0,3.236-3.425q.013-7.741,0-15.482C161.728,136.549,161.728,136.349,161.728,136.13Z",
    transform: "translate(-150.93 -136.13)",
    fill: "#66aa47"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.be710bfe95cb17c3853a87ff1c862c31.svg";
export { ForwardRef as ReactComponent };